import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { FileObject } from './models'

class API {
  api: AxiosInstance

  constructor() {
    this.api = axios.create({
      // baseURL: 'https://vaulture-api.herokuapp.com',
      // TODO: setup env vars for this.
      baseURL: 'https://vaulture-api.bifrostcloud.com/',

      //...
    })
  }

  private get headers(): AxiosRequestConfig {
    return {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('id_token') || '',
      },
    }
  }

  userInit = async (): Promise<boolean> => {
    const { data } = await this.api.get('/userInit', this.headers)
    return data
  }

  listFiles = async (path: string[]): Promise<FileObject[]> => {
    const { data } = await this.api.post(
      '/listContents',
      { path },
      this.headers,
    )
    return data
  }

  createFolder = async (folderPath: string): Promise<FileObject[]> => {
    const { data } = await this.api.post(
      '/createFolder',
      { folderPath },
      this.headers,
    )
    return data
  }

  deleteFile = async (key: string): Promise<boolean> => {
    const { data } = await this.api.post('/delete', { key }, this.headers)
    return data
  }

  downloadFile = async (key: string): Promise<string> => {
    const { data } = await this.api.post(
      '/download',
      { fileName: key },
      this.headers,
    )
    return data
  }

  requestSignature = async (selectedFile: any, path: string) => {
    const { data } = await this.api.post(
      '/requestSignature',
      {
        name: path + selectedFile.name,
        type: selectedFile.type,
      },
      this.headers,
    )

    return data
  }

  // extra apis
  getShareURL = async (fileURL: string): Promise<string> => {
    const { data } = await this.api.post(
      '/shareURL',
      {
        fileURL,
      },
      this.headers,
    )
    return data
  }
}

export const storageAPI = new API()
